import React from 'react'
import { Helmet } from 'react-helmet'

import Advantages from '../components/Advantages/Advantages'
import AboutUs from '../components/AboutUs/AboutUs'
import OurWork from '../components/OurWork/OurWork'
import QuestionsRemain from '../components/QuestionsRemain/QuestionsRemain'

import { getCommonLDScripts } from '../services/seo'

import './about-us.css'

const PageAboutUs = () => (
  <>
  <Helmet script={getCommonLDScripts()}>
    <meta name='author' content='Xpart' />
    <meta name="robots" content="index,follow" />
    <meta name='theme-color' content='#1a7fc8' />
    <meta name='local' property='og:local' content='uk_UA' />
    <meta name='site_name' property='og:site_name' content={window.location.hostname} />
  </Helmet>
  <div className='page__about-us'>
    <AboutUs />
    <Advantages />
    <OurWork />
    <QuestionsRemain className='questions-remain--without-margins' />
  </div>
  </>
)

export default PageAboutUs
